import {Module, Component} from '../decorators';
import _ from 'lodash';
import R from 'app/resource';
import CompanyStore from 'app/stores/company';

import BasePicker from './base.picker';
import tpl from './tank.picker.html';


@Module({
    name: "app.compontents.tank",
    modules: [R, CompanyStore],
})
@Component({
    selector: 'blnd-tank-picker',
    template: tpl,
    bindings: {
        ngModel: '=',
        mode: '@?',
        type: '@?',
        company: '<',
    },
})
export default class C extends BasePicker {
    constructor (CompanyStore, $element) {
        "ngInject";
        super($element);
        this.mode = this.mode || 'view';
        this.type = this.type || 'fert_tanks';

        this.list = [];
        this.loaded = false;
        this.CompanyStore = CompanyStore;
    }

    refresh () {
        if (!this.enabled || this.loaded) { return; }
        this.loaded = true;
        let self = this;
        return this.CompanyStore.get(self.company.id).then(function (response) {
            self.list = _.map(response[self.type], (o) => o.key);
            return self;
        });
    }

    onKeyDown() {
        this.enabled = true;
    }

    $onDestroy () {
        delete this.list;
        super.$onDestroy();
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/tank.picker.js